import React, {useState,useEffect} from 'react';
import {Form, Input, Button, Checkbox, Carousel} from 'antd';
import {UserOutlined, LockOutlined, CopyrightOutlined} from '@ant-design/icons';
import {http, history, addVisitLog} from 'libs';
import styles from './login.module.less';
import gStore from 'store';
import axios from 'axios';

// the hook
import {useTranslation} from 'react-i18next';

export default function Login() {
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);

  const username = localStorage.getItem('username');
  const password = localStorage.getItem('password');
  const remember = localStorage.getItem('remember');
  const clearLocalStorageIfNecessary = async ()=> {
    const storedVersion = localStorage.getItem('version_no');
    console.log(storedVersion,'storedVersion');
    
    const timestamp = new Date().getTime()
    const response = await axios.get(`${window.location.origin}?time=${timestamp}`)
    // 返回的是字符串，需要转换为 html
    const el = document.createElement('html')
    el.innerHTML = response?.data
    let newVersion = ''
    // 拿到版本号
    const metaList = el.querySelectorAll('meta')
    if (!metaList.length) return
  
    for (let i = 0; i < metaList.length; i++) {
      const item = metaList[i]
      if (item.name === 'version_no') {
        newVersion = item.content
        break
      }
    }
    if (storedVersion !== newVersion) {
      // 如果版本不同，则刷新浏览器
      localStorage.setItem('version_no', newVersion);
      window.location.reload(true);
    }
  }

  function handleSubmit(formData) {
    setLoading(true);
    const f_Data = formData;
    f_Data['from'] = 2;
    http.post('/javaApi/user/login', f_Data)
      .then(loginResult => {
        let data = loginResult.data.result;
        gStore.isLogin = false;
        localStorage.setItem('token', data['token']);
        localStorage.setItem('username', formData['loginName']);
        localStorage.setItem('password', formData['loginPass']);
        localStorage.setItem('remember', formData['remember']);
        http.get('/javaApi/front/customer/getUserInfo')
        .then(res => {
          const userInfo=res.data.result;
          addVisitLog({
            pageName: "登录",
            fromPageUrl: window.referrerUrl,
            pageUrl:`${window.location.origin}${history.location.pathname}`,
            eventCode: "Login",
            eventName: "登录",
            content: JSON.stringify(userInfo)
          })
          // localStorage.setItem('nickname', res.data.result['name']);
          // localStorage.setItem('userInfo', JSON.stringify(res.data.result));
          localStorage.setItem('nickname', userInfo['name']);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          clearLocalStorageIfNecessary();
            // if (history.location.state && history.location.state['from']) {
            //   history.push(history.location.state['from'])
            // } else {
            //   let redirect_uri = localStorage.getItem('redirect_uri')
            //   history.push(redirect_uri ? redirect_uri : '/home')
            // }
            history.push('/home')
        })
      }, () => setLoading(false))
  }

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        <div className={styles.h1}>{t('请登录您的账号')}</div>
        <Form onFinish={handleSubmit}
              initialValues={remember === 'true' ? {loginName: username, loginPass: password, remember: true} : {loginName: null, loginPass: null, remember: false}}>

          <Form.Item name="loginName" className={styles.formItem}>
            <Input
              size="large"
              placeholder={t('手机号/邮箱')}
              prefix={<UserOutlined className={styles.icon}/>}/>
          </Form.Item>

          <Form.Item name="loginPass" className={styles.formItem}>
            <Input
              size="large"
              type="password"
              placeholder={t('请输入密码')}
              prefix={<LockOutlined className={styles.icon}/>}/>
          </Form.Item>

          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>{t('自动登录')}</Checkbox>
            </Form.Item>

            {/* <a className={styles['form-forgot']} disabled
               >{t('忘记密码') + '？'}</a> */}
          </Form.Item>

          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" loading={loading}>{t('登录')}</Button>
            {/* <div className={styles.formTip}>
              {t('如果您没有平台账号')} <a onClick={() => {
              // history.push('/register')
            }} disabled>{t('立即注册')}!</a>
            </div> */}
          </Form.Item>

        </Form>
      </div>
    </div>
  )
}
